import React, { useEffect } from 'react';

import useBranch from 'client/hooks/useBranch';
import ListingActions from 'client/actions/Listing';

import SrBox from 'client/components/SrBox';
import SrPriceMarketFitSunSpotChart from 'client/components/SrPriceMarketFitSunSpot/SrPriceMarketFitSunSpotChart';

const formatWeeklyLeads = ({
  listing,
  weeklyLeads,
}) => {
  const sunSpotArea = listing.avgLeadsComposition * 0.3;

  const data = weeklyLeads.reduce((memo, week) => {
    return [
      ...memo,
      {
        ...week,
        sunSpot: sunSpotArea,
        cold: week.sunSpotPoint - (sunSpotArea / 2),
      },
    ];
  }, []);

  return data;
};

const SrPriceMarketFitSunSpot = ({
  listing,
}) => {
  const {
    weeklyLeads,
    priceChanges,
    dispatch,
  } = useBranch({
    weeklyLeads: ['listings', 'weeklyLeads', listing.id],
    priceChanges: ['listings', 'priceChanges', listing.id],
  });

  useEffect(() => {
    dispatch(ListingActions.getWeeklyLeads, { listingId: listing.id });
    dispatch(ListingActions.getPriceChanges, { listingId: listing.id });
  }, [listing, dispatch]);

  if (!weeklyLeads || !priceChanges) {
    return (
      <div className='loading-gif clearfix' />
    );
  }

  return (
    <SrBox padding='0'>
      <SrPriceMarketFitSunSpotChart
        listing={listing}
        weeklyLeads={formatWeeklyLeads({
          listing,
          weeklyLeads,
        })}
        priceChanges={priceChanges}
      />
    </SrBox>
  );
};

SrPriceMarketFitSunSpot.displayName = 'SrPriceMarketFitSunSpot';

export default SrPriceMarketFitSunSpot;
